import { Backdrop, IconButton, SvgIcon } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { AxiosResponseHeaders } from "axios";
import QuantityRestriction from "components/modals/QuantityRestriciton";
import { MediumText } from "components/typography";
import { fetchValidateResponse } from "features/shoppingCart/fetchValidate";
import { checkAddToShoppingCart, setShoppingCart } from "features/shoppingCart/shoppingCartSlice";
import { selectUserIsLoggedId } from "features/user/userSlice";
import { AddShoppingCart } from "icons";
import { LotOfferLocationInterface } from "interfaces/LotOfferLocationInterface";
import React from "react";

export interface ShoppingCartButtonInterface {
  lotInformation: LotOfferLocationInterface;
  onClick?: (event?: any) => void;
  withLabel?: boolean;
  disabled?: boolean;
}

export default function ShoppingCartButton({ lotInformation, onClick = undefined, withLabel = false, disabled = false }: ShoppingCartButtonInterface) {
  const [error, setError] = React.useState("");
  
  const dispatch = useAppDispatch();
  const isLoggedIn = useAppSelector(selectUserIsLoggedId);
  const handleAddToCartClick = (event: any) => {
    event.stopPropagation();
    // if (!isLoggedIn) {

    //   return;
    // }
    if (isLoggedIn) {
      dispatch(checkAddToShoppingCart([{ 
          id: lotInformation.id, 
          price: lotInformation.price, 
          vat_rate: lotInformation.vat_rate,
          full_lot_number: lotInformation.full_lot_number
      }])).then((response) => {
        
        if (response.meta.requestStatus === "fulfilled") {
          const payload = response.payload as { headers: AxiosResponseHeaders; data: fetchValidateResponse, status: number };
          // Has lot overflow warning when added
          const lotErrors = payload.data.data?.errors?.filter((e) => e.id === lotInformation.id);
          lotErrors?.forEach((lotError) => {
            showError(lotError.error);
          });
          if (payload.status >= 400 && payload.status !== 401) {
            setError("Beim Hinzufügen zum Warenkorb ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
            return false;
          }
          return !lotErrors || lotErrors?.length === 0;
        }
        return false;
      }).then((result) => {
        if (result) {
          onClick?.(event);
          dispatch(setShoppingCart(lotInformation));
        }
      });
    } else {
      onClick?.(event);
      dispatch(setShoppingCart(lotInformation));
    }
  };

  const showError = (error: string) => {
    setError(error);
  };
  const closeError = (event: any) => {
    event.stopPropagation();
    setError("");
  };
  return (
    <>
      <IconButton
        sx={{
          float: "right",
          backgroundColor: "#D9E868",
          borderRadius: withLabel ? "26px" : "50%",
          color: "#000000",
          "&:hover": { backgroundColor: "#D9E868" },
          padding: 1,
          // TODO: This Comes from Selected LotInfoSmall Styling
          // padding: "4px 6px"
          minWidth: "20px",
          gap: 1,
        }}
        onClick={handleAddToCartClick}
        disabled={disabled}
      >
        {withLabel ? (
          <MediumText color="#072D26" fWeight="bold">
            In den Einkaufswagen
          </MediumText>
        ) : null}
        <SvgIcon>
          <AddShoppingCart />
        </SvgIcon>
      </IconButton>
      <Backdrop sx={{ backgroundColor: "#grey", zIndex: 1200 }} open={!!error} onClick={closeError}>
        <QuantityRestriction
          onClickEvent={closeError}
          checked={!!error}
          handleClose={closeError}
          text={error}
        />
      </Backdrop>
    </>
  );
}
